module.exports = __webpack_public_path__ + "img/Group4_26sp_english.c503e101.jpg";